/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCursorOff = createReactComponent("outline", "cursor-off", "IconCursorOff", [["path", { "d": "M9 4a3 3 0 0 1 3 3v1m0 9a3 3 0 0 1 -3 3", "key": "svg-0" }], ["path", { "d": "M15 4a3 3 0 0 0 -3 3v1m0 4v5a3 3 0 0 0 3 3", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

export { IconCursorOff as default };
//# sourceMappingURL=IconCursorOff.mjs.map
